import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import RulesCard from "./RulesCard";
import Live2DAvatar from "../Live2D/Live2DAnimation4";

function Rules() {
  return (
    <div className="rules-section main">
    <Container fluid className="profileBox">
      <Container fluid>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={6}
            style={{
              justifyContent: "center",
              paddingBottom: "50px",
            }}
          >
            <div className="section-title">
            <h2 style={{ fontSize: "2.0em" }}>@sakasakitty</h2>
            <strong>—</strong><br/>
            <div className="subtitle">rules;</div>
            </div>
            <RulesCard />
          </Col>
          <Col md={6}>
            <div id="avatar" className="ImgSide">
            <Live2DAvatar path ={"/Resources/l2dstill_rei4_whitemoon/l2dstill_rei4_whitemoon.model3.json"}/>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
    </div>
  );
}

export default Rules;
